import { html } from "htm/preact";
import { hydrate } from "preact";
import ButtonTop from "../components/ButtonTop.js";

const el = document.getElementById("button-top-island");
if (el) {
  hydrate(html`<${ButtonTop} />`, el);
}